import React from 'react';
import { Heart, Users, Package } from 'lucide-react';

const ImpactStory = () => {
  return (
    <section id="impact-story" className="impact-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Community Leadership in Crisis</h2>
          <p className="section-subtitle">Leading by example: translating values into action during the COVID-19 pandemic</p>
        </div>

        <div className="impact-grid">
          <div className="impact-image">
            <img 
              src="/images/covid_meal_delivery.jpg" 
              alt="Zane Powles delivering school meals during COVID-19 lockdown"
              className="story-image"
            />
          </div>

          <div className="impact-content">
            <div className="stats-grid">
              <div className="stat-card">
                <Package size={40} />
                <h3>15,000+</h3>
                <p>Meals Delivered</p>
              </div>
              <div className="stat-card">
                <Users size={40} />
                <h3>110</h3>
                <p>Families Supported</p>
              </div>
              <div className="stat-card">
                <Heart size={40} />
                <h3>900+</h3>
                <p>Miles Walked</p>
              </div>
            </div>

            <div className="story-text">
              <p>
                When COVID-19 closed schools, I led an immediate, whole-school response to ensure vulnerable children maintained access to nutrition, safeguarding checks, and educational support. This wasn't just about meals—it was strategic crisis management ensuring continuity of care while schools pivoted to remote learning.
              </p>
              <p>
                Growing from 85 to 110 families, I walked over 900 miles delivering 15,000+ meals while conducting welfare checks and providing learning materials. This initiative demonstrated servant leadership in action, earned national recognition including an MBE presented by Princess Anne at Windsor Castle, and reinforced that effective leadership means being present when communities need you most.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactStory;